import { Type } from '@angular/core';
import { IframeDialog } from '@app/services/iframe-bridge.service';

/**
 * Single registry for ExtJS `BridgePortlet` → Angular lazy chunks.
 * Add a new entry here when adding a portlet in `TI.settings.riskScore` + `IframeDialog.Events`.
 */
export const SETTINGS_BRIDGE_PORTLET_LOADERS: Record<string, () => Promise<Type<unknown>>> = {
  [IframeDialog.Events.settingsDocumentRiskPortlet]: () =>
    import('@app/pages/main/pages/settings/components/document-risk/document-risk.component').then(
      (m) => m.DocumentRiskComponent,
    ),

  [IframeDialog.Events.settingsSiteRiskPortlet]: () =>
    import('@app/pages/main/pages/settings/components/site-risk/site-risk.component').then(
      (m) => m.SiteRiskComponent,
    ),
};

export const SETTINGS_BRIDGE_PORTLET_IDS = Object.keys(SETTINGS_BRIDGE_PORTLET_LOADERS);
